/* ==========================================================================
   Campaign Detail Drawer — Tabs, Accordion, Budget Bars
   ========================================================================== */
(function () {
  'use strict';

  var overlay = document.getElementById('drawerOverlay');
  var drawer  = document.getElementById('campaignDrawer');
  var body    = document.getElementById('drawerBody');
  var title   = document.getElementById('drawerTitle');
  var pillar  = document.getElementById('drawerPillar');
  var tabs    = document.getElementById('drawerTabs');
  var closeBtn = document.getElementById('drawerClose');

  if (!drawer || !body) return;

  /* ---- Open ---- */
  function openDrawer(key, campaignTitle, campaignPillar) {
    var tpl = document.getElementById('drawer-' + key);
    if (!tpl) return;

    title.textContent = campaignTitle;
    pillar.textContent = campaignPillar;
    body.innerHTML = tpl.innerHTML;

    setActiveTab('overview');

    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  /* ---- Close ---- */
  function closeDrawer() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    setTimeout(function () { body.innerHTML = ''; }, 320);
  }

  /* ---- Tabs ---- */
  function setActiveTab(name) {
    tabs.querySelectorAll('.hi-drawer__tab').forEach(function (t) {
      t.classList.toggle('active', t.dataset.drawerTab === name);
    });
    body.querySelectorAll('[data-drawer-panel]').forEach(function (p) {
      p.classList.toggle('active', p.dataset.drawerPanel === name);
    });
    body.scrollTop = 0;
    if (name === 'budget') setTimeout(animateBudgetBars, 80);
    if (name === 'docs') setTimeout(initSlider, 50);
  }

  /* ---- Image slider (in docs tab) ---- */
  function initSlider() {
    var slider = body.querySelector('.hi-drawer__slider');
    if (!slider || slider.dataset.init === '1') return;
    slider.dataset.init = '1';

    var track = slider.querySelector('.hi-drawer__slider-track');
    var slides = track ? track.querySelectorAll('.hi-drawer__slider-slide') : [];
    var prev = slider.querySelector('.hi-drawer__slider-nav--prev');
    var next = slider.querySelector('.hi-drawer__slider-nav--next');
    var dotsWrap = slider.querySelector('.hi-drawer__slider-dots');
    if (!track || slides.length === 0) return;

    var currentIdx = 0;

    // Build dots
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < slides.length; i++) {
        var dot = document.createElement('button');
        dot.className = 'hi-drawer__slider-dot';
        dot.type = 'button';
        dot.dataset.slideIdx = i;
        dot.setAttribute('aria-label', 'Go to photo ' + (i + 1));
        dotsWrap.appendChild(dot);
      }
    }

    function updateSlider(idx) {
      currentIdx = Math.max(0, Math.min(idx, slides.length - 1));
      slides.forEach(function (s, i) {
        s.classList.toggle('active', i === currentIdx);
      });
      if (dotsWrap) {
        dotsWrap.querySelectorAll('.hi-drawer__slider-dot').forEach(function (d, i) {
          d.classList.toggle('active', i === currentIdx);
        });
      }
      if (prev) prev.disabled = currentIdx === 0;
      if (next) next.disabled = currentIdx === slides.length - 1;
    }

    if (prev) prev.addEventListener('click', function () { updateSlider(currentIdx - 1); });
    if (next) next.addEventListener('click', function () { updateSlider(currentIdx + 1); });
    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var d = e.target.closest('.hi-drawer__slider-dot');
        if (d) updateSlider(parseInt(d.dataset.slideIdx, 10));
      });
    }

    // Hide nav if only 1 slide
    if (slides.length <= 1) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      if (dotsWrap) dotsWrap.style.display = 'none';
    }

    updateSlider(0);
  }

  /* ---- Budget bars ---- */
  function animateBudgetBars() {
    body.querySelectorAll('.hi-drawer__budget-bar-fill').forEach(function (bar) {
      bar.style.width = bar.dataset.width + '%';
    });
  }

  /* ---- Event delegation: Learn More buttons ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-open-drawer]');
    if (btn) {
      e.preventDefault();
      openDrawer(
        btn.dataset.openDrawer,
        btn.dataset.drawerTitle || '',
        btn.dataset.drawerPillar || ''
      );
    }
  });

  /* ---- Close handlers ---- */
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('active')) closeDrawer();
  });

  /* ---- Tab clicks (event delegation) ---- */
  tabs.addEventListener('click', function (e) {
    var tab = e.target.closest('.hi-drawer__tab');
    if (tab && tab.dataset.drawerTab) setActiveTab(tab.dataset.drawerTab);
  });

  /* ---- FAQ accordion (event delegation on body) ---- */
  body.addEventListener('click', function (e) {
    var qBtn = e.target.closest('.hi-drawer__faq-q');
    if (!qBtn) return;
    var item = qBtn.closest('.hi-drawer__faq-item');
    if (item) item.classList.toggle('active');
  });

  /* ---- Docs: image lightbox (event delegation on body) ---- */
  body.addEventListener('click', function (e) {
    var imgItem = e.target.closest('.hi-drawer__docs-item--img');
    if (imgItem) {
      var src = imgItem.querySelector('img')?.src;
      if (!src) return;
      var lb = document.querySelector('.hi-lightbox');
      if (lb) {
        lb.querySelector('.hi-lightbox__img').src = src;
        lb.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }
  });

  /* ---- Docs: video play (event delegation on body) ---- */
  body.addEventListener('click', function (e) {
    var vidItem = e.target.closest('.hi-drawer__docs-item--video');
    if (!vidItem) return;
    e.preventDefault();

    var videoUrl = vidItem.dataset.videoUrl;
    if (!videoUrl) return;

    var modal = document.getElementById('docsVideoModal');
    var container = document.getElementById('docsVideoContainer');
    if (!modal || !container) return;

    // Determine if YouTube/Vimeo or direct video
    if (videoUrl.indexOf('youtube.com') > -1 || videoUrl.indexOf('youtu.be') > -1) {
      var vid = videoUrl.match(/(?:v=|youtu\.be\/|embed\/)([^&?\/]+)/);
      if (vid) {
        container.innerHTML = '<iframe width="854" height="480" src="https://www.youtube-nocookie.com/embed/' + vid[1] + '?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
      }
    } else if (videoUrl.indexOf('vimeo.com') > -1) {
      var vId = videoUrl.match(/vimeo\.com\/(\d+)/);
      if (vId) {
        container.innerHTML = '<iframe width="854" height="480" src="https://player.vimeo.com/video/' + vId[1] + '?autoplay=1" allow="autoplay" allowfullscreen></iframe>';
      }
    } else {
      container.innerHTML = '<video controls autoplay style="max-width:90vw;max-height:80vh;border-radius:8px"><source src="' + videoUrl + '"></video>';
    }

    modal.classList.add('active');
  });

  /* ---- Video modal close ---- */
  document.addEventListener('click', function (e) {
    var closeV = e.target.closest('.hi-drawer__video-modal__close');
    var modal = document.getElementById('docsVideoModal');
    if (!modal) return;
    if (closeV || e.target === modal) {
      modal.classList.remove('active');
      document.getElementById('docsVideoContainer').innerHTML = '';
    }
  });

  /* ---- Docs: PDF open in modal ---- */
  body.addEventListener('click', function (e) {
    var pdfLink = e.target.closest('.hi-drawer__docs-pdf');
    if (!pdfLink) return;
    e.preventDefault();

    var pdfUrl = pdfLink.dataset.pdfUrl;
    var pdfTitle = pdfLink.dataset.pdfTitle || 'PDF Document';
    if (!pdfUrl) return;

    var modal = document.getElementById('docsPdfModal');
    var frame = document.getElementById('docsPdfFrame');
    var titleEl = document.getElementById('docsPdfTitle');
    var dlEl = document.getElementById('docsPdfDownload');
    if (!modal || !frame) return;

    if (titleEl) titleEl.textContent = pdfTitle;
    if (dlEl) dlEl.href = pdfUrl;
    frame.innerHTML = '<iframe src="' + pdfUrl + '#toolbar=1&navpanes=0" title="' + pdfTitle.replace(/"/g, '&quot;') + '" loading="lazy"></iframe>';
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  /* ---- PDF modal close ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#docsPdfClose')) {
      var modal = document.getElementById('docsPdfModal');
      var frame = document.getElementById('docsPdfFrame');
      if (modal) modal.classList.remove('active');
      if (frame) frame.innerHTML = '';
      if (!drawer.classList.contains('active')) {
        document.body.style.overflow = '';
      }
    }
  });

  /* ---- ESC closes PDF modal too ---- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var pdfModal = document.getElementById('docsPdfModal');
    if (pdfModal && pdfModal.classList.contains('active')) {
      pdfModal.classList.remove('active');
      var frame = document.getElementById('docsPdfFrame');
      if (frame) frame.innerHTML = '';
      e.stopPropagation();
    }
  });

  /* ---- Re-init on Shopify editor reload ---- */
  document.addEventListener('shopify:section:load', function () {
    closeDrawer();
  });
})();
